module.exports = __webpack_public_path__ + "static/media/posting_photo.ee01a6cb.svg";